// src/config.ts
var SceneConifg = {
  REGISTERED_PROTOCOLS: {}
};
export {
  SceneConifg
};
